import { createActionTypes } from "../utils/fn";

export default createActionTypes(
  "td_flow",
  "ASSESMENT_CHANGED",
  "RESET_ASSESMENTS",
  "FIELD_CHANGED",
  "FETCH_FLOW",
  "LOADING",
  "FETCH_FAIL",
  "INITIALIZE_FLOW",
  "INITIALIZE_SCREEN",
  "INITIALIZE_SCREEN_PREV",
  "NEXT_SCREEN",
  "PREV_SCREEN",
  "PREV_SCREEN_SUCCESS",
  "PREV_SCREEN_FAILED",
  "SHOW_GLOBAL_DIALOG",
  "CLEAR_GLOBAL_DIALOG",
  "RESET_STORE",
  "PHARMACIES_FOUND",
  "CAPSULE_PHARMACY_FOUND",
  "PICK_PHARMACY_ON_MAP",
  "SET_CONSULT_STATE",
  "SET_FILTERS",
  "RESET_FILTERS",
  "RESET_STATE",
  "SET_STATE",
  "DELETE_FROM_STATE",
  "SET_DETAIL_PROVIDER_DATA",
  "RESET_DETAIL_PROVIDER_DATA",
  "SET_DETAIL_PROVIDER_FIELDS_DATA",
  "CARE_TEAM_SET_DETAIL_PROVIDER_FIELDS_DATA",
  "SET_TREATMENT_DATA",
  "DELETE_TREATMENT_DATA",
  "UPDATE_TREATMENT_DATA",
  "RESET_TREATMENT_DATA",
  "SET_TREATMENT_TO_EDIT",
  "RESET_TREATMENT_TO_EDIT",
  "SET_VALIDATION",
  "RESET_VALIDATION",
  "RESET_FIELD_VALIDATION_ALL",
  "ADD_TOAST",
  "REMOVE_TOAST",
  "UPDATE_HISTORY",
  "UPDATE_HISTORY_ACTION",
  "SET_FIELD_VALIDATION",
  "RESET_FIELD_VALIDATION",
  "RESET_FIELDS_VALIDATION",
  "DEPENDENT_STORED_SUCCESS",
  "RESET_DEPENDENT",
  "CARE_RECIPIENT_STORED_SUCCESS",
  "RESET_CARE_RECIPIENT",
  "ADD_TRACKING_EVENT",
  "RESET_TRACKING_EVENTS",
  "SET_SCREEN_PARAMS",
  "SET_FORM_GROUP_ERRORS",
  "FETCH_AVAILABLE_TIMES_PENDING",
  "FETCH_AVAILABLE_TIMES_SUCCESS",
  "FETCH_AVAILABLE_TIMES_FAILURE",
  "SET_SELECTED_DATE",
  "SET_SELECTED_TIME",
  "CLEAR_DATE_TIME_SELECTION",
  "ADD_CALL_TO_ACTION_BUTTON_IS_LOADING",
  "REMOVE_CALL_TO_ACTION_BUTTON_IS_LOADING",
  "SET_SHOW_HUD",
  "RESET_SHOW_HUD",
  "SET_SETTINGS",
  "INITIALIZE_DIALOG",
  "CLEAR_DIALOG_FLOW",
  "RESET_ACTION_FIELD",
  "SET_FORM_ERRORS_FROM_BACK",
  "PII_COLLECTED_SUCCESS",
  "SET_PAGE_NUMBER",
  "SET_SELECTED_LIST_ITEM",
  "RESET_FORM_FIELDS",
  "ITEM_SELECTED",
  "RESET_ITEM_SELECTED",
  "LOADED"
);
